import React from 'react';
import { StyledExpandCollapseButton, Icon } from './ExpandCollapseButton.styles';
import { iconViewList, iconViewGrid } from '../../../../../design-tokens';

type Props = {
    expanded: boolean;
    text: string;
    toggleExpand: (e: React.MouseEvent) => void;
};

const ExpandCollapseButton = ({ expanded, text, toggleExpand }: Props): JSX.Element => {
    const titleText = expanded ? `Visa ${text} på en rad` : `Visa ${text} på flera rader`;

    // Disable focus outline on mouse up
    const onMouseUp = (e) => {
        e.currentTarget.blur();
    };

    return (
        <StyledExpandCollapseButton
            type="button"
            onClick={toggleExpand}
            onMouseUp={onMouseUp}
            aria-expanded={expanded}
            title={titleText}
            data-rt="expand-button"
        >
            <Icon icon={iconViewList} aria-hidden="true" active={!expanded} />
            <Icon icon={iconViewGrid} aria-hidden="true" active={expanded} />
        </StyledExpandCollapseButton>
    );
};

export default ExpandCollapseButton;
